import script from "./ViversePromo.vue?vue&type=script&setup=true&lang=js"
export * from "./ViversePromo.vue?vue&type=script&setup=true&lang=js"

import "./ViversePromo.vue?vue&type=style&index=0&id=194df558&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-194df558"]])

export default __exports__